import React from 'react';
import classnames from 'classnames/bind';

import styles from './contact.scss';
let cx = classnames.bind(styles);

const Contact = ({ locale, translations }) => {
    return (
        <main className={cx('contact', 'flex', 'column')}>
            <div className={cx('title')}>{translations['CONTACT']}</div>
            <p>
                <b>PNK Team 👋</b>
                <br /><br />
                Contact us at this email:
                <br />
                <a href="mailto:contact@pnk.app">contact@pnk.app</a>
                <br />
            </p>
        </main>
    );
};

export default Contact;
